import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {Kpi} from '../../../../models/common';
import {CommonConstant, InfluencerTabName} from '../../../app.constants';
import {Influencer} from '../../../../models/influencer';
import {FilterSearch} from '../../../../models/filter-search';
import {ReferenceDataService} from '../../../services/reference-data/reference-data.service';
import {DiscoverService} from '../../../services/discover/discover.service';
import {UserService} from '../../../services/user.service';
import {InfluencerService} from '../../../services/influencer/influencer.service';
import {ObjectUtils} from '../../../utils/object.utils';

@Component({
  selector: 'influencer-overview-tab',
  templateUrl: './influencer-overview-tab.component.html',
  styleUrls: ['./influencer-overview-tab.component.scss']
})
export class InfluencerOverviewTabComponent implements OnInit, OnDestroy {

  @Input() influencerId: number;
  @Output() changeActiveChannel: EventEmitter<any> = new EventEmitter<any>();

  public channelKpi: Kpi | null;
  public isAuthorized = true;
  public posts: Array<Influencer>;
  public influencerGroupId: number;
  public scrollDistance = CommonConstant.DEFAULT_INFINITE_SCROLL_DISTANCE;
  public throttle = CommonConstant.DEFAULT_INFINITE_SCROLL_THROTTLE_100;
  public currentFilterSearch: FilterSearch = new FilterSearch();
  public platformList;
  private currentInfluencer: any;
  private searchAfter = [];
  public isLoading = false;
  public isShowPopUp = false;
  public currentPost: Influencer;
  // the current active channel
  private activeChannel: any;
  private channelChangeSubscription;
  // flag to indicate if the channel selection is enable
  public showChannelDropdown = false;
  constructor(private discoverService: DiscoverService,
              private influencerService: InfluencerService,
              private userService: UserService,
              private referenceService: ReferenceDataService) {
    this.platformList = this.referenceService.platforms;
  }

  ngOnInit() {
    this.currentInfluencer = this.userService.getInfluencerInfo();
    // intialize search criteria
    this.currentFilterSearch = new FilterSearch();
    this.currentFilterSearch.limit = 50;
    this.currentFilterSearch.offset = 0;
    this.currentFilterSearch.orderBy = 'latest';
    this.currentFilterSearch.period = 60;
    // load post list of influencer
    if (this.showChannelDropdown) {
      this.channelChangeSubscription = this.influencerService.activeChannel.subscribe((channel) => {
        if (channel && !ObjectUtils.isEquals(channel, this.activeChannel)) {
          this.activeChannel = channel;
          this.loadPostByChannel(channel);
          this.loadInfluencerKpi(this.activeChannel);
        }
      });
    } else {
      this.loadPostByChannel(null);
      this.loadInfluencerKpi(null);
    }
  }

  ngOnDestroy() {
    if (this.channelChangeSubscription) {
      this.channelChangeSubscription.unsubscribe();
    }
  }

  loadInfluencerKpi(channel) {
    this.influencerService.getInfluencer(this.currentInfluencer.id).subscribe((res) => {
      this.channelKpi = this.getKpiByChannel(res.channelGlobalKpis, res.globalKpi, channel);
    });
  }

  private getKpiByChannel(channelGlobalKpis: any[], globalKpi, activeChannel: any) {
    if (!activeChannel) {
      return globalKpi;
    }
    if (!Array.isArray(channelGlobalKpis) || channelGlobalKpis.length === 0) {
      return null;
    }
    return channelGlobalKpis.find(gk => gk.channelId === activeChannel.id);
  }

  public onChangePlatform(platform) {
    this.influencerService.updateActiveChannel(platform);
    this.changeActiveChannel.emit({
      activeTab: InfluencerTabName.OVERVIEW,
      channel: platform.id
    });
  }

  private loadPostByChannel(platform) {
    this.isAuthorized = true;
    this.currentFilterSearch.mentions = [];
    this.currentFilterSearch.platforms = [];
    if (platform && platform.id > 0) {
      this.currentFilterSearch.mentions.push(`@${platform.handle}`);
      this.currentFilterSearch.platforms.push(platform.platformId);
    } else {
      this.currentFilterSearch.mentions = this.currentInfluencer.influencerChannels.map(c => `@${c.handle}`);
    }
    this.fetchPosts(false);
  }
  private fetchPosts(isScrolling) {
    if (isScrolling) {
      this.currentFilterSearch.searchAfter = this.searchAfter;
    } else {
      this.currentFilterSearch.searchAfter = [];
    }

    delete this.currentFilterSearch['topics'];
    delete this.currentFilterSearch['industries'];
    this.isLoading = true;
    this.discoverService.searchPosts(this.currentFilterSearch)
    // update the catching data with preloaded data	        // update the catching data with preloaded data
      .subscribe((res) => {
        // update the total result post and pagination data
        this.updateSearchAfter(res.lastSortValues);
        const nextResult = res.posts.filter(p => p.influencer_id === this.currentInfluencer.id);
        if (isScrolling) {
          this.posts = this.posts.concat(nextResult);
        } else {
          this.posts = nextResult;
        }
        // waiting for mansory rendering
        setTimeout(() => {
          this.isLoading = false;
        }, 1000);
      }, (err) => {
        this.isLoading = false;
      });
  }

  private updateSearchAfter(lastSortValues) {
    this.searchAfter = lastSortValues;
    this.currentFilterSearch.searchAfter = [];
    if (lastSortValues != null && lastSortValues.length > 0) {
      this.currentFilterSearch.searchAfter = lastSortValues;
    }
  }

  onScrollDown() {
    this.fetchPosts(true);
  }
  orderPostList(evt) {
    this.posts = [];
    this.currentFilterSearch.orderBy = evt;
    this.fetchPosts(false);
  }

  hidePopup() {
    this.isShowPopUp = false;
  }

}



// WEBPACK FOOTER //
// ./src/app/influencer-platform/influencer-details/influencer-overview-tab/influencer-overview-tab.component.ts